module.exports = __webpack_public_path__ + "static/media/tinyUser.48941886.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyUser.svg
// module id = 505
// module chunks = 0